/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Divider, Skeleton, View } from '@az/starc-ui';

export const LoadingOverview = () => {
  return (
    <View direction={{ s: 'column', l: 'row' }} align={'stretch'}>
      <View direction={{ s: 'row', l: 'column' }} justify={{ s: 'space-between', l: 'start' }}>
        <View>
          <Skeleton className={styles.rating} />
          <Skeleton className={styles.recommend} />
          <Skeleton className={styles.recommendations} />
        </View>
        <Skeleton className={styles.reviews} />
      </View>
      <Skeleton className={styles.overview} />
      <View.Item className={styles.dividerContainer}>
        <Divider vertical />
      </View.Item>
      <View padding={[10, 0, 0, 0]} />
      <View attributes={{ style: { flex: '1 1 0' } }}>
        <Skeleton className={styles.overviewHeading} />
        <View className={styles.distributionsContainer}>
          <Skeleton className={styles.distribution} />
          <Skeleton className={styles.distribution} />
          <Skeleton className={styles.distribution} />
          <Skeleton className={styles.distribution} />
          <Skeleton className={styles.distribution} />
        </View>
      </View>
      <View align={'center'} padding={[6, 0, 0, 0]}>
        <Skeleton className={styles.reviewModalButton} />
      </View>
      <View padding={[4, 0, 0, 0]} />
    </View>
  );
};
